import { Strapi4ResponseSingle } from "@nuxtjs/strapi/dist/runtime/types";
import { AsyncDataOptions } from "nuxt/app";

export default async function useStrapiPage<T>(slug: string, key: string, options = {}) {
  const { findOne } = useStrapi();

  const response = await useAsyncData(
    key,
    () => findOne<T>(`/slugify/slugs/page/${slug}`, {
      'populate': ['*', 'content.images']
    }),
    {
      transform: flattenObject,
      ...options
    }
  )

  if (!response.data.value) {
    throw createError({ statusCode: 404, message: "Pagina niet gevonden", fatal: true });
  }

  return response;
}
